import { DIRECTION_NAME_TO_SLUG } from './icons'

export * from './mocks'
export * from './utils'
export * from './icons'
export * from './day'
export * from './dictionary'
export * from './individualLessonSignup'

export type Query = {
  /**
   * @minLength 2
   * @maxLength 50
   */
  q?: string | null
}

export type Slug =
  | 'default'
  | 'football'
  | 'basketbol'
  | 'swimming'
  | 'sportivnoe-plavanie'
  | 'boxing'
  | 'gymnastics'
  | 'xokkei'
  | 'saxmaty'
  | 'tancy'
  | 'tennis'
  | 'badminton'
  | 'beg'
  | 'voleibol'
  | 'golf'
  | 'snorkling'
  | string
  | undefined

export const SLUG_CARD_COLORS = {
  default: 'linear-gradient(41.08deg, #9BE68C 11.79%, #42BE54 76.62%)',
  football: 'linear-gradient(41.08deg, #9BE68C 11.79%, #42BE54 76.62%)',
  basketbol: 'linear-gradient(180deg, #278EE0 0%, #C3E4FF 100%)',
  swimming: 'linear-gradient(180deg, #FFE0DB 0%, #FFEAE8 100%)',
  'sportivnoe-plavanie': 'linear-gradient(180deg, #A3D6FF 0%, #63A9E0 100%)',
  boxing:
    'linear-gradient(180deg, rgba(255, 157, 157, 0.5) 0%, rgba(255, 134, 59, 0.5) 100%)',
  gymnastics: 'linear-gradient(257.06deg, #9DD1FC 14.04%, #6BA8DA 88.7%)',
  xokkei: 'linear-gradient(180deg, #FFDDC4 0%, #FFAF76 100%)',
  saxmaty:
    'linear-gradient(180deg, rgba(255, 235, 157, 0.5) 0%, rgba(255, 216, 59, 0.5) 100%)',
  tancy: 'linear-gradient(180deg, #89DDDA 0%, #1E8380 100%)',
  tennis:
    'linear-gradient(145.93deg, rgba(233, 166, 40, 0.2) 25.96%, rgba(233, 166, 40, 0.6) 79.75%)',
  badminton:
    'linear-gradient(72.05deg, rgba(83, 123, 159, 0.3) 17.87%, rgba(83, 123, 159, 0.6) 87.71%)',
  beg: 'linear-gradient(41.08deg, #9BE68C 11.79%, #42BE54 76.62%)',
  voleibol: 'linear-gradient(180deg, #278EE0 0%, #C3E4FF 100%)',
  golf: 'linear-gradient(180deg, #FFE0DB 0%, #FFEAE8 100%)',
  snorkling: 'linear-gradient(180deg, #A3D6FF 0%, #63A9E0 100%)',
}

export const DIRECTION_CARD_COLORS: string[] = [
  'linear-gradient(41.08deg, #9BE68C 11.79%, #42BE54 76.62%)',
  'linear-gradient(180deg, #278EE0 0%, #C3E4FF 100%)',
  'linear-gradient(180deg, #FFE0DB 0%, #FFEAE8 100%)',
  'linear-gradient(180deg, #A3D6FF 0%, #63A9E0 100%)',
  'linear-gradient(180deg, rgba(255, 157, 157, 0.5) 0%, rgba(255, 134, 59, 0.5) 100%)',
  'linear-gradient(257.06deg, #9DD1FC 14.04%, #6BA8DA 88.7%)',
  'linear-gradient(180deg, #FFDDC4 0%, #FFAF76 100%)',
  'linear-gradient(180deg, rgba(255, 235, 157, 0.5) 0%, rgba(255, 216, 59, 0.5) 100%)',
  'linear-gradient(180deg, #89DDDA 0%, #1E8380 100%)',
  'linear-gradient(145.93deg, rgba(233, 166, 40, 0.2) 25.96%, rgba(233, 166, 40, 0.6) 79.75%)',
  'linear-gradient(72.05deg, rgba(83, 123, 159, 0.3) 17.87%, rgba(83, 123, 159, 0.6) 87.71%)',
]

/** Цвета карточек расписания: плашка направления + фон тела (Figma Schedule card) */
export type ScheduleDirectionPalette = {
  header: string
  card: string
}

/** Figma: Schedule card/completed */
export const SCHEDULE_FINISHED_COLORS: ScheduleDirectionPalette = {
  header: '#9299a4',
  card: '#8691a30d',
}

/** Figma: Schedule card/full */
export const SCHEDULE_FULL_COLORS: ScheduleDirectionPalette = {
  header: '#9db4ff80',
  card: '#2196f30f',
}

/** Figma: Schedule card/accepted («Вы записаны») */
export const SCHEDULE_ACCEPTED_COLORS: ScheduleDirectionPalette = {
  header: '#46a527',
  card: '#36d3031a',
}

/** Цвета из инстансов school lesson card в макете */
export const SCHEDULE_DIRECTION_COLORS: Record<
  string,
  ScheduleDirectionPalette
> = {
  football: { header: '#46a527', card: '#36d3031a' },
  beg: { header: '#46a527', card: '#36d3031a' },
  running: { header: '#46a527', card: '#36d3031a' },

  swimming: { header: '#9db4ff', card: '#2196f31a' },
  'sportivnoe-plavanie': { header: '#9db4ff', card: '#2196f31a' },
  snorkling: { header: '#9db4ff', card: '#2196f31a' },

  voleibol: { header: '#f6a904', card: '#f597001a' },
  volleyball: { header: '#f6a904', card: '#f597001a' },
  basketbol: { header: '#f6a904', card: '#f597001a' },
  basketball: { header: '#f6a904', card: '#f597001a' },
  tennis: { header: '#f6a904', card: '#f597001a' },

  saxmaty: { header: '#00949e', card: '#00858f1a' },
  chess: { header: '#00949e', card: '#00858f1a' },
  tancy: { header: '#00949e', card: '#00858f1a' },

  boxing: { header: '#ff863b', card: '#ff863b1a' },
  xokkei: { header: '#ff863b', card: '#ff863b1a' },
  hockey: { header: '#ff863b', card: '#ff863b1a' },
  gymnastics: { header: '#9db4ff', card: '#2196f31a' },
  badminton: { header: '#00949e', card: '#00858f1a' },
  golf: { header: '#f6a904', card: '#f597001a' },

  default: { header: '#46a527', card: '#36d3031a' },
}

export function getScheduleDirectionColors(
  direction?: { slug?: string; name?: string } | null,
): ScheduleDirectionPalette {
  if (!direction) return SCHEDULE_DIRECTION_COLORS.default!

  const slug =
    direction.slug ||
    (direction.name ? DIRECTION_NAME_TO_SLUG[direction.name] : undefined)

  if (slug && SCHEDULE_DIRECTION_COLORS[slug]) {
    return SCHEDULE_DIRECTION_COLORS[slug]!
  }

  return SCHEDULE_DIRECTION_COLORS.default!
}

export function getReadingTime(text: string) {
  const wordsPerMinute = 225 // Average adult reading speed
  const words = text.trim().split(/\s+/).length // Split by spaces to count words
  const time = Math.ceil(words / wordsPerMinute) // Round up to the nearest minute

  return `${time} мин`
}

export async function copyToClipboard(text: string) {
  if (!import.meta.client || !navigator?.clipboard) return

  try {
    await navigator.clipboard.writeText(text)
    console.log('Скопировано в буфер обмена!')
  } catch (error) {
    console.error('Произошла ошибка при копировании: ', error)
  }
}

/**
 * Склонение числительных в русском языке.
 * @example declOfNum(1, ['яблоко', 'яблока', 'яблок']) // 'яблоко'
 * @example declOfNum(2, ['яблоко', 'яблока', 'яблок']) // 'яблока'
 * @example declOfNum(5, ['яблоко', 'яблока', 'яблок']) // 'яблок'
 */
export function declOfNum(
  number: number = 0,
  titles: [string, string, string],
): string {
  const cases = [2, 0, 1, 1, 1, 2] as const
  const index =
    number % 100 > 4 && number % 100 < 20 ? 2 : cases[Math.min(number % 10, 5)]!
  return titles[index]
}

/**
 * Склонение числительного с выводом числа и единицы измерения.
 * @example declOfNumWithVal(1, ['яблоко', 'яблока', 'яблок']) // '1 яблоко'
 * @example declOfNumWithVal(3, ['яблоко', 'яблока', 'яблок']) // '3 яблока'
 * @example declOfNumWithVal(7, ['яблоко', 'яблока', 'яблок']) // '7 яблок'
 */
export function declOfNumWithVal(
  number: number = 0,
  titles: [string, string, string],
): string {
  return `${number} ${declOfNum(number, titles)}`
}
